var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferenceContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 22V38H27.3333V22H15.3333ZM25.9999 36.6667H16.6666V23.3333H25.9999V36.6667ZM15.3333 40.6667H44.6666V42H15.3333V40.6667ZM15.3333 18H44.6666V19.3333H15.3333V18ZM29.9999 23.3333H44.6666V24.6667H29.9999V23.3333ZM29.9999 27.3333H44.6666V28.6667H29.9999V27.3333ZM29.9999 31.3333H44.6666V32.6667H29.9999V31.3333ZM29.9999 35.3333H44.6666V36.6667H29.9999V35.3333Z",
    fill: "#FFFF81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferenceContent);
export default __webpack_public_path__ + "static/media/difference_content.a8b24e01789785b1edf3354f2a13c571.svg";
export { ForwardRef as ReactComponent };